var map = {
	"../pages/categories/categories.module": [
		282,
		15
	],
	"../pages/inventory/inventory.module": [
		283,
		14
	],
	"../pages/login/login.module": [
		284,
		13
	],
	"../pages/modal-category/modal-category.module": [
		285,
		6
	],
	"../pages/modal-employee-id/modal-employee-id.module": [
		287,
		5
	],
	"../pages/modal-enter-creditcard/modal-enter-creditcard.module": [
		286,
		4
	],
	"../pages/modal-item-add/modal-item-add.module": [
		288,
		3
	],
	"../pages/modal-item/modal-item.module": [
		289,
		2
	],
	"../pages/modal-select-item/modal-select-item.module": [
		290,
		1
	],
	"../pages/modal-show-details/modal-show-details.module": [
		291,
		0
	],
	"../pages/payment-confirmation/payment-confirmation.module": [
		292,
		12
	],
	"../pages/payment/payment.module": [
		293,
		11
	],
	"../pages/pos-tabs/pos-tabs.module": [
		294,
		10
	],
	"../pages/pos/pos.module": [
		295,
		9
	],
	"../pages/reports/reports.module": [
		296,
		8
	],
	"../pages/settings/settings.module": [
		297,
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 165;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 165
// module chunks = 16